import React, { memo, useCallback, useMemo } from 'react';
import { Text } from '@cuemath/web-comps';
import { CheckCircle } from '@styled-icons/material/CheckCircle';
import { Cancel } from '@styled-icons/material/Cancel';
import { RadioButtonChecked } from '@styled-icons/material/RadioButtonChecked';
import { RadioButtonUnchecked } from '@styled-icons/material/RadioButtonUnchecked';
import COLORS from 'constants/colors';
import { formatDurationMs } from '../../helpers';
import { VERDICT_DISPLAY, VERDICT_STATES } from '../../constants';
import { EventPillButton } from './event-pill-styled';

const ICON_SIZE = 14;

const VERDICT_ICONS = {
  [VERDICT_STATES.VALID]: CheckCircle,
  [VERDICT_STATES.INVALID]: Cancel,
};

const EventPill = ({ event, index, isActive, onSelect, isReviewSubmitted }) => {
  const verdictKey = useMemo(() => {
    if (event.is_valid === true) return VERDICT_STATES.VALID;
    if (event.is_valid === false) return VERDICT_STATES.INVALID;
    return VERDICT_STATES.PENDING;
  }, [event.is_valid]);
  const { color, bgColor, borderColor } = VERDICT_DISPLAY[verdictKey];
  const handleClick = useCallback(() => onSelect(index), [onSelect, index]);
  const isPending = verdictKey === VERDICT_STATES.PENDING;
  const iconColor = isPending && !isActive ? COLORS.BLACK_T_60 : color;

  const IconComponent = isPending
    ? (isActive ? RadioButtonChecked : RadioButtonUnchecked)
    : VERDICT_ICONS[verdictKey];

  return (
    <EventPillButton bg={bgColor} border={borderColor} isActive={isActive} hasVerdict={!isPending} onClick={handleClick}>
      <IconComponent size={ICON_SIZE} color={iconColor} />
      <Text variant="body3" color={isPending && !isActive ? COLORS.BLACK_T_60 : color} weight={isActive ? '500' : undefined}>
        Event {index + 1}
        {event.total_duration != null && ` \u2022 ${formatDurationMs(event.total_duration)}`}
        {isActive && (isPending ? ' \u2022 ready' : isReviewSubmitted ? ' \u2022 view' : ' \u2022 re-review')}
      </Text>
    </EventPillButton>
  );
};

export default memo(EventPill);
